import { useMemo, useCallback, useEffect } from "react";
import { FlaskReq } from "helpers/Request";
import { PAGE_NUMBER } from "./helper";

function BarcodeScanner() {
  let inputString = "",
    minLength = 4,
    eventName = "barcode",
    eventBarcode,
    timeout;

  const isValid = () => inputString.length >= minLength;

  document.addEventListener("keypress", onKeyPress, { capture: true });

  function stop() {
    document.removeEventListener("keypress", onKeyPress);
    document.removeEventListener(eventName, eventBarcode);
    clearTimeout(timeout);
  }

  function listen(listener) {
    document.removeEventListener(eventName, eventBarcode);
    eventBarcode = e => listener(e, e.detail);
    document.addEventListener(eventName, eventBarcode);
  }

  function reset() {
    if (isValid()) {
      document.dispatchEvent(
        new CustomEvent(eventName, { detail: inputString })
      );
    }

    inputString = "";
  }

  function onKeyPress(event) {
    clearTimeout(timeout);

    if (event.which === 13) {
      if (isValid()) {
        const originalElement = event.srcElement || event.originalTarget;

        if (originalElement?.type !== "text") {
          event.stopPropagation();
          event.preventDefault();
        }
      }

      reset();

      return;
    }

    inputString += String.fromCharCode(event.which);
    timeout = setTimeout(reset, 40);
  }

  return {
    stop,
    listen
  };
}

BarcodeScanner.init = listener => {
  const barcodeScanner = new BarcodeScanner();
  barcodeScanner.listen(listener);
  return barcodeScanner;
};

export function useBarcodeScanner(onBarcodeScan, deps) {
  const barcodeScanner = useMemo(() => new BarcodeScanner(), []);
  const onBarcodeScanCallback = useCallback(onBarcodeScan, deps);

  useEffect(() => {
    barcodeScanner.listen(onBarcodeScanCallback);

    return () => {
      barcodeScanner.stop();
    };
  }, [onBarcodeScanCallback]);
}

export const onBarcodeSearch = async (barcode) => {
  async function getProduct(url) {
    const {
      data: {
        assets,
        parts,
        pages: { total }
      }
    } = await FlaskReq({ url, method: "get" });

    if (total !== PAGE_NUMBER.ONE) return false;

    return (assets || parts)[0];
  }
  const generateUrl = type =>
  `${localStorage.flask_url}/${type}/?barcode=${barcode}`;

  return (
    (await getProduct(generateUrl("assets"))) ||
    (await getProduct(generateUrl("parts")))
  );
};

export function useBarcodeScannerProductSearch(setState: Function, updatePage = true) {
  useBarcodeScanner(
    async (event, barcode) => {
      const product = await onBarcodeSearch(barcode);

      if(updatePage) {
        setState({
          page: PAGE_NUMBER.ONE,
          searchText: product.productNumber
        })
        return
      }
      setState(product.productNumber)
    },
    []
  );
}

export default BarcodeScanner;
